var _g, _ellipse, _ellipse2, _g2, _g3, _path, _g4, _g5, _path2, _path3, _g6, _path4, _path5, _path6, _g7, _g8, _g9, _path7, _path8, _g0, _g1, _g10, _path9, _path0, _path1, _path10, _g11, _g12, _path11, _g13, _path12, _path13, _path14, _path15, _path16, _path17, _g14, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g15, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g16, _path32, _path33, _path34, _path35, _g17, _path36;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 474.611,
    height: 405.125,
    viewBox: "0 0 474.611 405.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(-12.695 -43.227)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M112.412,94.738c15.62,1.045,22.155-9.612,29.494-23.31,20.093-37.5,64.838-33.888,79.848-10.8,10.631,16.357,33.558,12.992,52.1,6.591,18.254-6.3,49.354-12.354,74.125-4.824,21.636,6.576,30.514,30.3,50.237,28.842,43.025-3.184,64.716,39.293,56.923,57.818-5.086,12.092-7.611,25.617-3.476,38.059,4.555,13.7,14.958,24.551,23.367,36.331s15.181,26.506,11,40.326c-3.577,11.825-14.247,20.006-20.871,30.464-20.568,32.474-.221,82.242-27.628,109.31-19.618,19.375-51.6,14.9-79.053,18.6-22.891,3.084-44.433,12.7-67.221,16.464-46.147,7.627-92.75-9.173-139.533-9.647-16.479-.167-33.266,1.669-49.227-2.394C81.207,421.15,63.085,404.765,55.7,384.253c-10.195-28.3-.535-61.062-12.053-88.865-9.383-22.65-32.328-41.076-30.884-65.517.9-15.215,11.294-27.943,18.443-41.44C41.828,168.373,27.76,89.073,112.412,94.738ZM248.59,58c-4.1,0-7.433,2.55-7.433,5.7s3.337,5.424,7.433,5.695c13.35.882,13.35-4.515,13.35-7.66C261.94,56.7,252.7,58,248.59,58ZM384.166,82.28a21.97,21.97,0,0,0,12.761,4.951,5.105,5.105,0,0,0,3.544-.8,2.9,2.9,0,0,0,.262-4.069,6.808,6.808,0,0,0-2.517-1.377,7.915,7.915,0,0,1-3.885-2.9,2.851,2.851,0,0,0-.883-1.1C390.864,75.532,379.469,78.4,384.166,82.28Zm22.74,5.031a5.839,5.839,0,0,0,3.646-.352c.758-.246,1.689-.788,1.485-1.553a1.423,1.423,0,0,0-.783-.793c-1.557-.833-3.575-1.447-5.14-.382S405.731,86.906,406.906,87.311ZM461.2,194.576a10.422,10.422,0,0,0,2.354,4.745,39.947,39.947,0,0,0,6.8,7.769,6.891,6.891,0,0,0,3.932,1.791,6.164,6.164,0,0,0,3.7-1.336,11.776,11.776,0,0,0,4.789-8.128c.5-4.4-1.547-8.689-3.929-12.439-1.475-2.323-3.2-4.638-5.665-5.883-4.138-2.088-6.873-.265-8.03,3.4C464.093,187.868,460.769,190.82,461.2,194.576ZM20.819,297.082c-2.179,1.92-.213,7.539.43,11.248a6.846,6.846,0,0,0,1.153,3.15,7.627,7.627,0,0,0,4.051,2.147c2.653.77,5.869,1.422,7.9-.442,1.5-1.382,1.716-3.636,1.713-5.668a52.908,52.908,0,0,0-.3-5.557,5.934,5.934,0,0,0-.7-2.557,5.693,5.693,0,0,0-2.745-1.981C28.525,295.816,23,295.162,20.819,297.082ZM154.038,437.849c-1.289.258-2.829.816-3.015,2.105-.154,1.066.743,1.976,1.611,2.623,7.114,5.307,16.687,5.646,25.592,5.77a7.582,7.582,0,0,0,3.073-.381,3.954,3.954,0,0,0,1.932-5.163,6.39,6.39,0,0,0-1.373-1.77C174.7,434.068,162.941,436.063,154.038,437.849ZM331.7,434.258c-8.029,5.874.091,11.115,10.232,7.225a141.989,141.989,0,0,1,16.3-5.569c1.808-.453,12.737-2.816,12.738-5.271,0-6.507-12.314-4.971-20.06-3.886A40.294,40.294,0,0,0,331.7,434.258Z",
    fill: "#d2e3fc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 38.647,
    cy: 3.611,
    rx: 38.647,
    ry: 3.611,
    transform: "translate(142.158 410.069)",
    fill: "#c8dbfb"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 38.647,
    cy: 3.611,
    rx: 38.647,
    ry: 3.611,
    transform: "translate(340.708 410.069)",
    fill: "#c8dbfb"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M461.011,159.461c-4.829-29.686-28.668-27.066-50.056-27.021l-352.509.727c-33.275.069-30.055,48.107-4,48.053,14.98-.031,20.676,28.1-5.224,28.152-17.279.035-15.959,24.388-1.672,24.358",
    fill: "none",
    stroke: "#c8dbfb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M51.635,232.822a4.789,4.789,0,1,1-5.526-3.916A4.79,4.79,0,0,1,51.635,232.822Z",
    fill: "#9fc2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M465.725,161.614a4.789,4.789,0,1,1-3.853-5.57A4.788,4.788,0,0,1,465.725,161.614Z",
    fill: "#9fc2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M100.45,197.84a83.434,83.434,0,0,1-2.93,11.44,194.883,194.883,0,0,1-10.01,23.57c-1.93,4.02-9.76,13.32-13.96,15.09a217.268,217.268,0,0,0-.69-33.33c-1.17-10.2,2.5-17.93-1.5-27.39-.51-1.21-1.04-2.42-1.57-3.63-1.99-4.5-3.96-9.02-4.58-13.87-.8-6.15,1.11-13.16,6.43-16.36,3.83-2.3,8.82-2.18,12.91-.37a23.985,23.985,0,0,1,9.86,8.83C101.38,172.18,102.64,185.56,100.45,197.84Z",
    fill: "#9fc2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M81.85,163.865c7.831,11.057,8.509,23.94,9.188,37.472a72.254,72.254,0,0,1-9.259,39.023",
    fill: "none",
    stroke: "#0b43a4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M81.523,367.845c-5.488-4.849-11.041-9.774-15.1-15.872-3.532-5.312-5.812-11.344-8.893-16.929-1.994-3.614-4.348-7.1-5.5-11.059s-.878-8.656,1.938-11.674c2.937-3.148,7.989-3.631,11.977-2.009s7.036,4.975,9.364,8.6a40.974,40.974,0,0,1,6.019,15.929c.78,5.122.581,10.355,1.376,15.475a51.811,51.811,0,0,0,4.366,13.721c1.833,3.964,6.477,11.031,7.662,15.1C91.451,380.762,83.862,369.913,81.523,367.845Z",
    fill: "#34a853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M62.334,317.55c5.218,2.284,7.293,8.508,8.382,14.1,1.239,6.363.964,13.254,3.882,19.043,5.5,10.906,12.65,23.321,17.967,27.03",
    fill: "none",
    stroke: "#137333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M54.513,352.925c-4.554-1.8-10.636-2.537-13.556,1.393-2.445,3.291-1.179,7.956.51,11.692,1.425,3.153,3.237,6.36,6.243,8.074a17.833,17.833,0,0,0,6.809,1.8,163.147,163.147,0,0,0,19.737,1.141,41.345,41.345,0,0,1,23.225,7.866C89.367,369.809,69.841,358.978,54.513,352.925Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M46.523,362.731c5.8.247,11.647.654,17.211,2.3,5.69,1.683,27.578,11.727,31,16",
    fill: "none",
    stroke: "#185abc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M104.19,321.971a38.575,38.575,0,0,0-26.984-17.226c-8.061-1.083-16.355.425-24.309-1.253a30.978,30.978,0,0,1-23.31-39.208c1.869-6.223,6.138-12.117,12.319-14.113a19.535,19.535,0,0,1,10.492-.106,29.159,29.159,0,0,1,8.846,3.823c6.223,3.939,11.247,10,15.027,16.439,3.43,5.851,11.894,14.963,17.65,20.889,3.377,3.462,5.83,5.83,5.83,5.83C103.7,301.952,101.854,316.119,104.19,321.971Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M40.109,268.161c19.367,8.745,40.494,20.2,54.23,36.417",
    fill: "none",
    stroke: "#044c11",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M96.194,302.4s-28.865-23.4-34.95-48.51c6.223,3.939,11.247,10,15.027,16.439,3.43,5.851,11.894,14.963,17.65,20.889C94.6,294.359,95.355,298.044,96.194,302.4Z",
    fill: "#5275a0",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M97.52,209.28a194.883,194.883,0,0,1-10.01,23.57c-1.93,4.02-9.76,13.32-13.96,15.09a217.268,217.268,0,0,0-.69-33.33c-1.17-10.2,2.5-17.93-1.5-27.39-.51-1.21-1.04-2.42-1.57-3.63.37.12.73.25,1.08.4,6.58,2.82,9.62,9.78,10.18,16.54.47,5.58-.54,11.17-1.29,16.72a22.086,22.086,0,0,0-.08,7.69.235.235,0,0,1,.02.08,2.88,2.88,0,0,0,5.62-.21l1.75-9.29c.52-2.78,1.09-5.69,3.37-7.63a4.814,4.814,0,0,1,3.24-1.21A4.438,4.438,0,0,1,97.52,209.28Z",
    fill: "#5275a0",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M96.2,296.532c-4.559-23.808-6.957-27.477-4.951-33.445,2.555-7.606,1.119-15.254,3.53-22.907s4.051-15.883,2.106-23.667c-.615-2.462-1.861-5.145-4.818-5.247a4.809,4.809,0,0,0-3.243,1.207c-2.279,1.942-2.855,4.851-3.375,7.63L83.706,229.4a2.882,2.882,0,0,1-5.623.2l-.017-.075a21.969,21.969,0,0,1,.073-7.687c.749-5.555,1.758-11.143,1.3-16.729-.56-6.759-3.6-13.72-10.186-16.533a11.63,11.63,0,0,0-7.426-.593c-6.872,1.763-8.65,8.479-7.643,14.213.71,4.036,2.6,7.746,4.315,11.469,4.181,9.091,1.114,17.429,1.693,27.419C61.784,268.653,96.2,296.532,96.2,296.532Z",
    fill: "#7bd0a9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M65.538,195.188c3.391,16.94,6.818,34,13.4,49.976,1.93,4.686,2.873,10.85,14.043,23.594",
    fill: "none",
    stroke: "#044c11",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M197.78,199.53c-3.51-4.01-6.75-8.09-10.16-12.02-2.21-2.55-4.49-5.04-6.97-7.4-1.23-1.18-2.5-2.32-3.84-3.43a107.826,107.826,0,0,0-26.21-16.01c-5.7-2.44-11.72-4.45-16.56-8.34s-8.32-10.26-6.71-16.25c1.17-4.32,4.84-7.68,9.05-9.22a24.072,24.072,0,0,1,13.23-.47c12.2,2.63,22.39,11.4,29.32,21.77.12.18.25.37.37.56,5.08,7.75,8.63,16.37,11.72,25.15.99,2.82,1.93,5.66,2.86,8.49C195.28,186.59,199.58,195.34,197.78,199.53Z",
    fill: "#9fc2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M141.973,136.573c13.309,2.538,22.731,11.351,32.6,20.631a72.274,72.274,0,0,1,20.384,34.54",
    fill: "none",
    stroke: "#0b43a4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M187.62,187.51a15.747,15.747,0,0,0,.19,4.16c-3.33-.76-5.64-5.93-7.16-11.56a86.9,86.9,0,0,1-2.46-14.12,61.09,61.09,0,0,1,1.11-17.27c5.08,7.75,8.63,16.37,11.72,25.15q-1.59,4.725-2.72,9.56A27.788,27.788,0,0,0,187.62,187.51Z",
    fill: "#5275a0",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M210.717,139.46c-1.126,4.991-4.142,9.3-6.8,13.678-1.4,2.3-2.708,4.673-3.929,7.073a107.547,107.547,0,0,0-8.857,24.224,19.661,19.661,0,0,0-.489,8.241c-6.562-1.5-9.175-20.146-9.621-25.69a60.444,60.444,0,0,1,5.023-29.353c1.795-4.014,4.11-7.954,7.678-10.524s8.6-3.472,12.372-1.232a10.085,10.085,0,0,1,4.439,6.139A15.24,15.24,0,0,1,210.717,139.46Z",
    fill: "#7bd0a9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M188.13,187.172c-4.08-10.247-1.6-31.937,4.944-45.568,1.972-4.107,4.779-7.958,8.714-10.253",
    fill: "none",
    stroke: "#044c11",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M210.717,139.46c-1.126,4.991-4.142,9.3-6.8,13.678-1.4,2.3-2.708,4.673-3.929,7.073a23.843,23.843,0,0,1-3.356-9.834c-.552-5.809,1.667-12.032,6.393-15.451a17.129,17.129,0,0,1,7.508-2.91A15.24,15.24,0,0,1,210.717,139.46Z",
    fill: "#5275a0",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M248.565,182.863a21.158,21.158,0,0,1-1.7,5.522c-2.91,6.3-9.016,11.7-18.17,16.1,0,0-.51-9.962-.616-12.627-.446-11.416-12.839-17.735-20.677-26.061-3.993-4.248-7.019-9.611-7.582-15.42s1.667-12.032,6.393-15.451c3.961-2.857,9.144-3.484,14.018-3.112,7.859.626,15.792,3.919,20.677,10.057a9.054,9.054,0,0,1,.573.722c3,4.089,4.535,9.069,5.66,14.029C249.1,165.213,249.978,174.155,248.565,182.863Z",
    fill: "#34a853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M209.581,141.05c8.577,4.436,17.169,9.8,22.165,18.063,6.968,11.528,5.449,26.529.075,38.88",
    fill: "none",
    stroke: "#137333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M392.063,256.514c5.467-9,2.675-20.576,4.578-30.934A34.179,34.179,0,0,1,408.872,205.2c3.978-3.161,9.566-5.418,14.061-3.049.974.513,2.131,1.235,3.069.658a2.453,2.453,0,0,0,.916-1.682c1.139-5.594-1.55-11.7.648-16.973,1.183-2.837,3.631-4.956,6.223-6.608a33.939,33.939,0,0,1,16.767-5.261,9.414,9.414,0,0,1,4.616.7c2.541,1.274,3.7,4.439,3.362,7.261a16.114,16.114,0,0,1-3.624,7.606c-5.743,7.507-14.155,13.986-15.264,23.371a6.093,6.093,0,0,0,.4,3.5c.527,1.025,1.506,1.757,2.057,2.77,1.768,3.25-1.648,6.935-4.985,8.533a28.765,28.765,0,0,1-9.717,2.689c-2.315.216-4.933.272-6.508,1.982-2.907,3.158.433,8.207-.177,12.456-.38,2.652-2.3,4.793-4.235,6.65a76.038,76.038,0,0,1-11.7,9.226c-3.4,2.176-6.991,4.1-10,6.782s-5.444,6.314-5.641,10.343",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M399.268,247.761c.893-4.363,2.923-8.4,4.931-12.37,3.14-6.21,6.341-12.511,11.083-17.6,3.6-3.867,7.991-6.926,11.653-10.736a39.939,39.939,0,0,0,6.582-9.138,31.607,31.607,0,0,1,3.044-5.3c1.518-1.891,3.593-3.238,5.4-4.856a23.143,23.143,0,0,0,5.722-7.892",
    fill: "none",
    stroke: "#00ad9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M470.57,262.76c-1.23,4.74-3.06,9.43-6.2,13.19a28.138,28.138,0,0,1-7.82,6.31,43.975,43.975,0,0,1-4.73,2.31,56.786,56.786,0,0,1-19.77,4.38c-9.88.37-20.04-1.81-29.52,1.01a29.086,29.086,0,0,0-11.65,6.75,28.342,28.342,0,0,0-5.23,6.61l1.29-8.2c2.39-8.82,4.83-17.8,9.71-25.53a67.173,67.173,0,0,1,11.59-13.38,96.681,96.681,0,0,1,23.17-16.2c6.88-3.34,14.52-5.69,22.12-4.76s15.05,5.72,17.42,12.99C472.47,252.91,471.81,258.01,470.57,262.76Z",
    fill: "#9fc2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M393.4,288.877a59.968,59.968,0,0,1,30.433-23.1c7.664-2.558,15.768-3.531,23.531-5.771s15.506-6.043,20.057-12.719",
    fill: "none",
    stroke: "#185abc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M398.184,367.649c.432-11.028,6.133-21.211,13.057-29.806,5.775-7.169,12.743-13.73,21.35-17,2.7-1.024,5.656-1.711,8.456-1.022s5.339,3.084,5.39,5.967c.044,2.433-1.59,4.557-3.309,6.279-5.658,5.667-12.971,9.3-19.825,13.445-11.781,7.119-22.977,16.623-27.652,29.57",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M402.543,358c7.2-16.059,25.835-30.417,38.128-32.211",
    fill: "none",
    stroke: "#00ad9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M393.683,376.417c-.1-1.848,5.93-6.68,7.288-7.912a69.819,69.819,0,0,1,25.92-14.812c3.825-1.2,7.887-2.072,11.712-1.15s7.335,4.057,7.711,8.185c.364,4-2.321,7.917-5.747,9.853s-7.433,2.229-11.253,2.007c-5.9-.344-11.7-1.811-17.625-1.765S397.445,371.466,393.683,376.417Z",
    fill: "#34a853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M399.822,370.806c12.113-6.562,30.425-10.833,43.72-9.223",
    fill: "none",
    stroke: "#00ad9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M248.565,182.863a21.158,21.158,0,0,1-1.7,5.522,96.167,96.167,0,0,1-8.888-35.215,19.463,19.463,0,0,1,2.931-11.3,9.054,9.054,0,0,1,.573.722c3,4.089,4.535,9.069,5.66,14.029C249.1,165.213,249.978,174.155,248.565,182.863Z",
    fill: "#5275a0",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M290.457,182.358c9.044-3.212,18.436-5.774,26.658-10.725a23.272,23.272,0,0,0,6.647-5.542,11.166,11.166,0,0,0,2.456-8.118c-.4-2.924-2.271-5.724-1.641-8.607.415-1.9,1.841-3.384,2.931-5a15.937,15.937,0,0,0,2.045-13.276c-1.417-4.765-4.988-8.577-7.02-13.113a21.886,21.886,0,0,1-1.692-11.9c-7.587.1-14.511,4.245-21.971,5.628-5.706,1.059-11.642.483-17.3,1.783a27.3,27.3,0,0,0-20.35,21.908,15.031,15.031,0,0,0-13.256,4.442,19.51,19.51,0,0,0-5.2,14.259c2.331,37.429,23.76,56.954,23.76,56.954S287.009,183.583,290.457,182.358Z",
    fill: "#7bd0a9"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M270.229,182.1c-.94-9.233,2.286-18.359,5.992-26.868,3.613-8.293,7.769-16.422,13.348-23.541s12.669-13.225,21.038-16.656",
    fill: "none",
    stroke: "#137333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M278.277,120.694a74.439,74.439,0,0,0,1.859,26.152",
    fill: "none",
    stroke: "#137333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M281.676,143.9c9.4-6.03,23.863-9.692,35.013-9.053",
    fill: "none",
    stroke: "#137333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M258.688,145.438c11.317,4.773,11.783,21.414,12.085,26.142",
    fill: "none",
    stroke: "#137333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M273.858,161c8.66-6.211,21.174-8.078,30.383-5.762",
    fill: "none",
    stroke: "#00ad9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M297.483,116.421a13.668,13.668,0,0,0-2.991,9.676",
    fill: "none",
    stroke: "#137333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M296.958,123.751c3.992-2.044,9.329-2.513,15.038-1.082",
    fill: "none",
    stroke: "#137333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M74.3,141.852c1.065-.056,8.319-5.43,11.113-7.24a7.641,7.641,0,0,0,2.133-1.8,2.693,2.693,0,0,0,.406-2.647,3.339,3.339,0,0,0-3.395-2.1c-3.615.007-4.869,1.2-6.627,3.012C72.115,137.088,74.3,141.852,74.3,141.852Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M106.821,163.524c3.158,1.42,6.534,2.834,9.968,2.4,1.332-.17,2.786-.776,3.23-2.044a2.985,2.985,0,0,0-1-3.086,7.13,7.13,0,0,0-3.107-1.4c-4.2-1.027-10.107-.459-14.27.724A36.678,36.678,0,0,0,106.821,163.524Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M127.624,116.87c-1.409-.889-2.965-2.08-2.964-3.746s1.744-2.944,3.415-2.952a7,7,0,0,1,4.477,2.005c5.315,4.665,4.653,9.986,4.653,9.986S129.193,117.861,127.624,116.87Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M131.815,102.638a6.835,6.835,0,0,1-3.238-2.305,2.2,2.2,0,0,1-.336-1.868c.365-1.035,1.012-1.963,3.618-1.49,8.25,1.5,10.047,7.146,10.047,7.146S134.005,103.58,131.815,102.638Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M155.985,115.135a13.038,13.038,0,0,0,8.812-4.518,8.068,8.068,0,0,0,1.771-3.279,3.587,3.587,0,0,0-.967-3.45,3.65,3.65,0,0,0-4.272,0,8.589,8.589,0,0,0-2.76,3.594C157.685,109.321,155.985,115.135,155.985,115.135Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M96.9,235.8,72.86,214.608c-4.271-3.765-8.63-7.639-11.335-12.648-5.814-10.768-2.462-24.759,5.389-34.146s19.353-14.928,30.907-18.962,23.579-6.863,34.593-12.2c6.907-3.346,13.852-8.33,15.746-15.767A15.732,15.732,0,0,0,133.852,101.3",
    fill: "none",
    stroke: "#185abc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M161.583,107.454c-2.189,6.723-10.717,10.813-14.609,16.637",
    fill: "none",
    stroke: "#0b43a4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M130.964,115.187c1.68,1.773,3.691,3.239,5.156,5.192,3.1,4.129,3.355,10.836-1.226,15",
    fill: "none",
    stroke: "#0b43a4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M87.817,152.824a45.739,45.739,0,0,0,25.279,9.424",
    fill: "none",
    stroke: "#0b43a4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M71.633,162.746a24.95,24.95,0,0,1,8.387-27.193",
    fill: "none",
    stroke: "#0b43a4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M330.047,122.191a3.532,3.532,0,0,1,.513-3.535,2.605,2.605,0,0,1,2.771-.62c7.029,3.091,6.269,14.057,6.269,14.057S332.933,131.13,330.047,122.191Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M329.876,142.733c-4.547,8.218,11.615,7.591,17.443,2.751C347.319,145.484,333.791,135.659,329.876,142.733Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M350.311,122.814c-1.1-1.5-1.487-3.744-.293-5.172a4,4,0,0,1,3.8-1.129,8.9,8.9,0,0,1,4.27,2.6c5.319,6.616,2.82,13.092,2.82,13.092S352.108,125.277,350.311,122.814Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M414.495,143.163a3.628,3.628,0,0,1,.7-3.738,3.175,3.175,0,0,1,2.364-.707,7.2,7.2,0,0,1,2.418.722,7.72,7.72,0,0,1,3.722,3.7c2,4.118.641,9.214.641,9.214S415.474,146.353,414.495,143.163Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M394.3,158.244a10.381,10.381,0,0,0-10.716-1.725,5.5,5.5,0,0,0-2.293,1.721c-1.276,1.765-.829,4.347.5,6.077A13.384,13.384,0,0,0,387.109,168c3.6,1.633,9.179,1.959,13.007,2.936C400.116,170.935,400.1,163.334,394.3,158.244Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M335.084,123.954c2.378,7.783,9.108,13.656,16.6,16.833s15.745,4.015,23.866,4.541,16.339.787,24.192,2.919c7.655,2.078,15.277,6.4,18.561,13.624,4,8.786.458,19.293-5.155,27.146s-13.171,14.183-18.6,22.164c-2.494,3.664-4.576,7.955-4.072,12.359.672,5.87,5.618,10.194,10.215,13.907",
    fill: "none",
    stroke: "#185abc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M353.8,121.1a46.582,46.582,0,0,1,10.73,23.222",
    fill: "none",
    stroke: "#0b43a4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M335.707,144.1a37.234,37.234,0,0,0,9.379,1.647,14.328,14.328,0,0,0,9.161-3.968",
    fill: "none",
    stroke: "#0b43a4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M419.761,143.647a15.886,15.886,0,0,1,4.785,10.711c.15,4.005-2.072,8.859-4.739,11.851",
    fill: "none",
    stroke: "#185abc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M389.6,161.823a160.254,160.254,0,0,0,17.173,14.09c2.922,2.055,8.724,4.689,11.3,4.011",
    fill: "none",
    stroke: "#185abc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M456.55,282.26a43.975,43.975,0,0,1-4.73,2.31,56.786,56.786,0,0,1-19.77,4.38c-9.88.37-20.04-1.81-29.52,1.01a29.086,29.086,0,0,0-11.65,6.75c-.33.16-.66.34-.99.53-.79-6.69,15.89-15.41,20.96-17.68a60.428,60.428,0,0,1,29.35-5.12c4.38.35,8.87,1.21,12.48,3.7A13.355,13.355,0,0,1,456.55,282.26Z",
    fill: "#5275a0",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M440.2,278.439c4.378.349,8.868,1.208,12.483,3.7s6.16,6.941,5.316,11.25c-.982,5.02-6.172,8.286-11.249,8.9s-10.151-.78-15.16-1.811a108.1,108.1,0,0,0-33.779-1.544,19.58,19.58,0,0,0-7.924,2.306c-.789-6.694,15.9-15.41,20.968-17.682A60.441,60.441,0,0,1,440.2,278.439Z",
    fill: "#7bd0a9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M394.228,297.022c8.284-7.281,29.548-12.223,44.585-10.631,4.531.48,9.1,1.832,12.582,4.77",
    fill: "none",
    stroke: "#00ad9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M378.754,215.223l80.885-.167a17.186,17.186,0,0,1,17.222,17.151h0a17.186,17.186,0,0,1-17.151,17.222l-55.328.114",
    fill: "none",
    stroke: "#185abc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M134.01,274.613l-56.567.117a9.7,9.7,0,0,0-9.681,9.721h0a9.7,9.7,0,0,0,9.721,9.68l16.493-.034",
    fill: "none",
    stroke: "#185abc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: 4
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M43.723,318.42c-19.378.04-19.783,28.945,4.875,28.894l363.381-.75c15.253-.031,16.864-23.829-1.993-23.79-37.526.077-38.772-17.82-17.937-17.863",
    fill: "none",
    stroke: "#c8dbfb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M48.258,317.615a4.789,4.789,0,1,1-5.526-3.916A4.789,4.789,0,0,1,48.258,317.615Z",
    fill: "#9fc2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M401.341,305.04a4.789,4.789,0,1,1-5.526-3.915A4.788,4.788,0,0,1,401.341,305.04Z",
    fill: "#0b43a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M406.557,388.612l-300.889.622a7.269,7.269,0,0,1-7.283-7.254l-.412-199.333a7.27,7.27,0,0,1,7.254-7.284l300.889-.621A7.269,7.269,0,0,1,413.4,182l.412,199.333A7.268,7.268,0,0,1,406.557,388.612Z",
    fill: "#5275a0",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M400.665,384.8l-300.889.621a7.269,7.269,0,0,1-7.283-7.254l-.412-199.333a7.27,7.27,0,0,1,7.254-7.284l300.889-.621a7.269,7.269,0,0,1,7.283,7.254l.412,199.333A7.27,7.27,0,0,1,400.665,384.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M399.735,170.936l-299.6.618a7.912,7.912,0,0,0-7.9,7.929l.014,6.88,315.426-.651-.014-6.88A7.912,7.912,0,0,0,399.735,170.936Z",
    fill: "#185abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M100.493,385.425l45.268-.094-.411-199.078-53.18.11.4,191.175A7.907,7.907,0,0,0,100.493,385.425Z",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_244",
    "data-name": "Path 244",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.739,384.8l-300.889.621a7.268,7.268,0,0,1-7.284-7.254l-.411-199.333a7.267,7.267,0,0,1,7.253-7.283l300.889-.621a7.268,7.268,0,0,1,7.284,7.253l.411,199.333A7.268,7.268,0,0,1,400.739,384.8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 99.84587860107422 383.4259948730469 L 400.7350158691406 382.8049926757813 C 402.1421813964844 382.8022155761719 403.4639892578125 382.2514953613281 404.4569702148438 381.2543640136719 C 405.4500122070313 380.2571716308594 405.9951782226563 378.9329223632813 405.9920043945313 377.5251159667969 L 405.5809936523438 178.1919860839844 C 405.5751953125 175.2932891845703 403.2122802734375 172.9349975585938 400.3136596679688 172.9349975585938 L 400.3011169433594 172.9349975585938 L 99.41200256347656 173.5559997558594 C 98.00483703613281 173.5587768554688 96.68299865722656 174.1094512939453 95.68995666503906 175.1065826416016 C 94.69696044921875 176.1036224365234 94.15183258056641 177.4275817871094 94.15499877929688 178.8348693847656 L 94.56600189208984 378.1679992675781 C 94.57179260253906 381.0672912597656 96.935546875 383.4259948730469 99.83521270751953 383.4259948730469 L 99.84587860107422 383.4259948730469 M 99.83519744873047 385.4259948730469 C 95.82694244384766 385.4259948730469 92.57398986816406 382.18212890625 92.56600189208984 378.1719970703125 L 92.15499877929688 178.8389892578125 C 92.14600372314453 174.8249969482422 95.39400482177734 171.5639953613281 99.40800476074219 171.5559997558594 L 400.2969970703125 170.9349975585938 C 400.3023986816406 170.9349822998047 400.3082580566406 170.9349670410156 400.3136596679688 170.9349670410156 C 404.3212280273438 170.9349670410156 407.572998046875 174.1793823242188 407.5809936523438 178.18798828125 L 407.9920043945313 377.52099609375 C 408.0010070800781 381.5360412597656 404.7529907226563 384.7969970703125 400.739013671875 384.8049926757813 L 99.84999847412109 385.4259948730469 C 99.84510040283203 385.4259948730469 99.84009552001953 385.4259948730469 99.83519744873047 385.4259948730469 Z",
    stroke: "none",
    fill: "#185abc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    d: "M2.786,0H37.673a2.787,2.787,0,0,1,2.787,2.787v.345a2.787,2.787,0,0,1-2.787,2.787H2.787A2.787,2.787,0,0,1,0,3.131V2.786A2.786,2.786,0,0,1,2.786,0Z",
    transform: "translate(100.442 364.366) rotate(-0.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 39.914,
    height: 39.914,
    rx: 5.106,
    transform: "translate(99.042 195.307) rotate(-0.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    d: "M3.639,0h103.48a3.64,3.64,0,0,1,3.64,3.64v.451a3.64,3.64,0,0,1-3.64,3.64H3.64A3.64,3.64,0,0,1,0,4.091V3.639A3.639,3.639,0,0,1,3.639,0Z",
    transform: "matrix(1, -0.002, 0.002, 1, 153.947, 316.61)",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 89.055,
    height: 7.731,
    rx: 3.64,
    transform: "translate(169.671 198.667) rotate(-0.118)",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 116.309,
    height: 7.731,
    rx: 3.64,
    transform: "matrix(1, -0.002, 0.002, 1, 271.685, 281.424)",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 110.758,
    height: 7.731,
    rx: 3.64,
    transform: "translate(153.98 332.594) rotate(-0.118)",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 110.758,
    height: 7.731,
    rx: 3.64,
    transform: "translate(154.013 348.577) rotate(-0.118)",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 116.309,
    height: 56.812,
    rx: 6.012,
    transform: "translate(271.744 309.926) rotate(-0.118)",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M109.538,178.8a2.549,2.549,0,1,1-2.554-2.544A2.549,2.549,0,0,1,109.538,178.8Z",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.549,
    cy: 2.549,
    r: 2.549,
    transform: "translate(115.231 176.235)",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M131.12,178.756a2.549,2.549,0,1,1-2.554-2.544A2.549,2.549,0,0,1,131.12,178.756Z",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 7.371,
    cy: 7.371,
    r: 7.371,
    transform: "translate(150.277 209.155) rotate(-84.28)",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    d: "M1.373,0H34.022a1.373,1.373,0,0,1,1.373,1.373v.17a1.374,1.374,0,0,1-1.374,1.374H1.374A1.374,1.374,0,0,1,0,1.543v-.17A1.373,1.373,0,0,1,1.373,0Z",
    transform: "translate(101.975 238.532) rotate(-0.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    d: "M1.374,0H34.021a1.374,1.374,0,0,1,1.374,1.374v.17a1.374,1.374,0,0,1-1.374,1.374H1.373A1.373,1.373,0,0,1,0,1.544v-.17A1.374,1.374,0,0,1,1.374,0Z",
    transform: "matrix(1, -0.002, 0.002, 1, 101.988, 244.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M173.4,260.793l-9.233.093.068,38.679-7.966.016a5.09,5.09,0,0,1-5.1-5.079l-.148-71.526a5.145,5.145,0,0,1,5.134-5.155l17.145-.044Z",
    fill: "#c8dbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    transform: "translate(151.007 217.832) rotate(-0.118)",
    fill: "none",
    stroke: "#c8dbfb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.279,
    height: 81.76,
    rx: 6.012,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87.279,
    height: 80.76,
    rx: 5.512,
    fill: "none"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M6.012,0H110.3a6.012,6.012,0,0,1,6.012,6.012V57.917a6.012,6.012,0,0,1-6.012,6.012H6.012A6.012,6.012,0,0,1,0,57.917V6.012A6.012,6.012,0,0,1,6.012,0Z",
    transform: "translate(267.136 188.39) rotate(12.735)",
    fill: "#c8dbfb"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M163.763,412.761l-14.233.029-3.483-18.133,21.124-.044Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M149.987,394.649c0,1.479-.279,3.963.707,4s.577-2.358,1.7-2.293c.717.041-.334,7.878,2.375,8.067,1.863.129,1.523-3.844,1.714-6.331a1.163,1.163,0,0,1,2.3-.239c.02,1.245-.06,2.079,0,3.5.1,2.366,3.739,1.738,3.609-1.425s-.008-5.3-.008-5.3Z",
    fill: "#d2e3fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M146.58,405.6a3.8,3.8,0,0,1-.841-.087,2.972,2.972,0,0,1-2.187-1.639c-1.451-3.076,2.369-8.84,2.518-9.1l.2,1.038c-.034.06-3.355,5.014-2.051,7.778a2.259,2.259,0,0,0,1.687,1.249,3.271,3.271,0,0,0,.715.073c5.126-.009,13.889-9.564,13.985-9.674.358-.43,1.028-.025.79.338C160.994,396.04,152.09,405.589,146.58,405.6Z",
    fill: "#0c2340"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M296.146,157.624c-20.228-.774-48.077,14.186-38.2,50.765-.214,3.093,1.638,5.3,3.607,4.7s.234-6.466.234-6.466c3.368-27.2,9.668-31.9,20.363-31.8l25.09-.052c6.2.914,17.473,5.251,19.164,27.021l6.246,1.154C333.139,187.213,329.332,158.893,296.146,157.624Z",
    fill: "#5275a0",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M296.146,154.438c-20.228-.774-48.077,14.186-38.2,50.765l3.841-1.77c3.368-27.2,9.668-31.9,20.363-31.8l25.09-.052c6.2.914,17.774,6.417,19.465,28.187l5.945-.012C333.139,184.027,329.332,155.707,296.146,154.438Z",
    fill: "#ea8600"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M292.009,155.033l-3,6.6s.358,3.719,4.008,3.642,4.137-1.763,4.137-1.763l.476-7.582Z",
    fill: "#ffb9a3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M307.453,149.526c-3.425,6.055-4.943,7.939-9.421,8.849-5.8,1.179-12.3-2.732-9.28-12.373,2.465-7.861,6.2-6.65,9.851-6.353S311.153,142.984,307.453,149.526Z",
    fill: "#ffb9a3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M293.839,144.748a2.455,2.455,0,0,0-2.788.674,3.054,3.054,0,0,0-.768,2.919,2.656,2.656,0,0,0-2.5,2.791c-.957-2.234-.44-4.559-.629-6.845s.061-4.773,1.543-6.525a7.444,7.444,0,0,1,2.222-1.712,11.488,11.488,0,0,1,10.318-.146,6.26,6.26,0,0,0,4.642.814c4.419-1.068,7,1.92,4.349,4.719a3.524,3.524,0,0,1,2.174,1.508.679.679,0,0,1,.018.663.768.768,0,0,1-.4.251,4.815,4.815,0,0,1-2.325.185c.3.253,1.938.352,2.432,1.306,1.317,2.538-3.9,1.256-4.7,1,.908.17,3.291,2.072,2.529,3.378-.151.257-3.369,2.133-6.752-1.8a6.17,6.17,0,0,0-2.934-2.068,4.618,4.618,0,0,0-2.756.427c-.646.243-2.3,1.247-2.769.649C294.224,146.285,294.893,145.273,293.839,144.748Z",
    fill: "#0c2340"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M327.347,199.771c-.9,3.086-1.8,3.392-.716,3.884s1.966-1.238,1.966-1.238l5.018,1s-1.132-3.26-1.922-3.653S327.347,199.771,327.347,199.771Z",
    fill: "#ffb9a3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M261.789,203.433c.655,1.628.836,1.639,1.749,3.6,1.746,3.741-2.343,9.655-4.881,3.2a18.065,18.065,0,0,1-.709-5.024Z",
    fill: "#ffb9a3"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M300.984,136.43c1.931.185,3.748-.488,5.645-.69,1.642-.175,3.581.068,4.64,1.5.251.339.8.043.58-.339a4.6,4.6,0,0,0-4.438-1.952c-2.169.142-4.23,1.064-6.427.915-.369-.025-.36.535,0,.57Z",
    fill: "#0c2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M302.362,134.538c-2.172.522-4.338-.626-6.531-.393a9.934,9.934,0,0,0-5.477,2.6c-.362.325.116.96.525.681,1.7-1.158,3.516-2.311,5.643-2.334,2.035-.022,4.036.913,6.039.172a.375.375,0,0,0-.2-.723Z",
    fill: "#0c2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M289.022,137.738a5.589,5.589,0,0,0-2.047,1.89,6.13,6.13,0,0,0-.763,2.634,11.987,11.987,0,0,0,.268,3.176c.142.753.186,1.926,1.077,2.181.4.114.576-.417.268-.636-.287-.2-.34-.638-.409-.955-.09-.415-.178-.831-.252-1.25a10.834,10.834,0,0,1-.2-2.592,5.229,5.229,0,0,1,2.292-4.044c.24-.172.028-.561-.237-.4Z",
    fill: "#0c2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M314.393,143.369a4.1,4.1,0,0,0-1.966-1.785,3.132,3.132,0,0,0-2.724-.054.3.3,0,0,0,.15.553c.389,0,.781-.044,1.17-.03a3.748,3.748,0,0,1,1.112.224,3.54,3.54,0,0,1,1.806,1.356.262.262,0,0,0,.452-.264Z",
    fill: "#0c2340"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M203.116,295.917c10.6,3.9,19.816,16.065,17.7,24.908-2.387,9.989-9.279,14.3-9.279,14.3l-2.171-4.011s5.509-8.614,5.031-12.681c-.767-6.515-8.993-10.866-8.993-10.866Z",
    fill: "#0b43a4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M177.005,408.64s-6.514,2.63-8.142,4.115l12.9-.025-.009-4.1Z",
    fill: "#0c2340"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M205.514,408.389a10.455,10.455,0,0,1,2.189,4.289l-8.8.018a10.309,10.309,0,0,1,1.642-4.3Z",
    fill: "#0c2340"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M206.05,408.58l-6.01.01c.12-7.08-1.34-31.21-2.75-49.25-.83-10.58-1.65-19.08-2.13-20.8l3.22-.71,12.15-2.7C212.61,344.63,207.81,388.25,206.05,408.58Z",
    fill: "#34a853"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M183.961,338.159c-4.688,7.385-5.9,60.743-7.862,70.633l5.7.324a517.35,517.35,0,0,1,20.489-71.461Z",
    fill: "#009790"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M204.69,337.65c-2.75,7.47-5.22,14.78-7.4,21.69-.83-10.58-1.65-19.08-2.13-20.8l3.22-.71Z",
    fill: "#5275a0",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M183.961,338.159c-4.688,7.385-5.9,60.743-7.862,70.633l5.7.324a517.35,517.35,0,0,1,20.489-71.461Z",
    fill: "#34a853"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M187.543,278.591s-3.649,13.9,5.466,13.887l-.54,3.553,6.922.757-1.5-4.951s1.369-8.744,1.46-10.321C199.527,278.567,191.266,273.372,187.543,278.591Z",
    fill: "#ffb9a3"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 2.686,
    height: 11.349,
    transform: "translate(162.316 263.008) rotate(-0.113)",
    fill: "#0c2340"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 19.33,
    height: 4.312,
    rx: 1.954,
    transform: "translate(153.984 258.713) rotate(-0.113)",
    fill: "#185abc"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M161.591,277.318c-.073-2.575-2.2-1.9-1.026-6.1.723-2.6,6.086.416,5.418,2.217s-1.436,4.649-1.436,4.649Z",
    fill: "#ffb9a3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M193.075,295.212c-13.631.9-14.528,5.5-20.628,4.778-9.028-1.064-7.448-17.829-6.332-23.842l-5.392.011S151,314.352,181.7,307.29c-1.179,6.69,6.455,17.616-.947,30.876,11.654,3.165,22.528,3.942,31.839-.063-1.63-2.2,3.342-24.387-6.394-40.362C204.3,294.623,194.072,295.146,193.075,295.212Z",
    fill: "#0056ec"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M193.075,295.212c-13.631.9-14.528,5.5-20.628,4.778-9.028-1.064-7.448-17.829-6.332-23.842l-5.392.011S151,314.352,181.7,307.29c-1.179,6.69,6.455,17.616-.947,30.876,11.654,3.165,22.528,3.942,31.839-.063-1.63-2.2,3.342-24.387-6.394-40.362C204.3,294.623,194.072,295.146,193.075,295.212Z",
    fill: "#185abc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M191.2,281.255c.888.227,1.923.4,2.4,1.154a2.8,2.8,0,0,1,.256,1.67,1.4,1.4,0,0,1,1.465-.955,1.36,1.36,0,0,1,1.187,1.26,2.211,2.211,0,0,1-.2.844,10.1,10.1,0,0,1-1.015,1.93c1.115.41,2.047,3.667,2.6,4.679,1.872-.468,6.038-2.078,6.4-8.71.169-3.089-.772-6.787-4.123-8.844-2.367-1.453-6.295-1.474-9-.781-2.2.561-5.7,2.755-4.068,5.32A6.963,6.963,0,0,0,191.2,281.255Z",
    fill: "#ea8600"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M202.872,277.033a3.282,3.282,0,0,1,3.64.862,7.012,7.012,0,0,1,.733,2.9,2.258,2.258,0,0,0,.631,1.29,2.717,2.717,0,0,0,1.683.519,38.333,38.333,0,0,1,4.4.138,4.04,4.04,0,0,1,3.338,2.414c.228.748.1,1.569.377,2.3.41,1.1,1.582,1.727,2.6,2.366a16.95,16.95,0,0,1,5.353,5.329,9.644,9.644,0,0,1,1.6,4.419c.1,1.572,1.235,3.646.933,5.194-.325,1.669-1.966,3.927-5.209,4.97-5.6,1.8-7.378,2.585-12.746-.606-.648-.385-1.913-1.694-2.5-2.162a2.855,2.855,0,0,1-.911-1.451,6.065,6.065,0,0,1,.874-4.6c.8-1.4,1.889-2.641,2.708-4.034a5.052,5.052,0,0,0,.848-2.729,1.468,1.468,0,0,0-.37-.992,1.664,1.664,0,0,0-.868-.392c-1.179-.231-2.476.013-3.544-.516a2.5,2.5,0,0,1-1.293-2.85c.21-.721.757-1.329.912-2.063a2.811,2.811,0,0,0-1.357-2.759,7.909,7.909,0,0,0-3.16-1.04,3.646,3.646,0,0,1-1.56-.5,2.09,2.09,0,0,1-.791-1.734C199.222,279.235,200.911,277.686,202.872,277.033Z",
    fill: "#ea8600"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M201.915,282.449a3.349,3.349,0,0,1,3.009,3.294,8.962,8.962,0,0,1-1.31,3.494c-.542,1.133-.874,2.559-.149,3.584.633.893,2.944,1.133,2.944,1.133s2.756-.216,3.574.747a2.914,2.914,0,0,1,.152,2.9,10.318,10.318,0,0,0-.989,2.869",
    fill: "none",
    stroke: "#ea8600",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M187.9,274.247a11.666,11.666,0,0,1,15.062,1.663",
    fill: "none",
    stroke: "#ea8600",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M362.634,290.681l-2.254,4.532,5.507,2.252.588-5.217Z",
    fill: "#ffb9a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M365.959,275.929c-12.492,5.438-7.374,18.617.23,17.069,3.7-.753,5.575-12.67,5.575-12.67Z",
    fill: "#ffb9a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M370.108,274.054a6.554,6.554,0,0,0-1.476-2.122,1.89,1.89,0,0,0-2.385-.125c-.84.781-.348,2.244.5,3.013-.733.089-1.6-.417-2.142.086-.409.382-.267,1.058-.033,1.566a6.963,6.963,0,0,0,2.56,2.934c-.634.36-1.368,1.056-.988,1.678.105.172.282.291.385.464.242.4.008.917-.236,1.319q-.591.975-1.273,1.892a1.115,1.115,0,0,1,1.79.31,1.9,1.9,0,0,1-.445,2.013,2,2,0,0,1-1.008.643c-.343.079-1.856,4.76-.675,5.676,1.459,1.134,6.424.15,7.141-1.131a3.176,3.176,0,0,0,2.809,1.163,1.727,1.727,0,0,0,1.272-2.387,2.922,2.922,0,0,0,3.525-4.23c.612-.185.735-1.014.579-1.633a3.775,3.775,0,0,0-2.585-2.657,1.279,1.279,0,0,0,1.165-1.258,2.63,2.63,0,0,0-.7-1.718A5.851,5.851,0,0,0,373.6,277.5C371.848,277.277,370.883,275.494,370.108,274.054Z",
    fill: "#fbcb43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M358.4,407.773s-7.309,3.509-8.289,4.6c0,0,14.38.647,15.506-.032s-2.3-4.581-2.3-4.581Z",
    fill: "#0c2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M385.592,403.8s-6.424,4.946-7.157,6.22c0,0,15.164-2.252,15.164-3.242s-3.2-4-3.2-4Z",
    fill: "#0c2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M365.469,340.01c-.27,1.487-10.276,40.992,18.355,64.676l8.294-1.9s-9.652-9.054-14.2-25.346c-4.3-15.406-.885-16.917,1.7-25.4,2.855-9.393.73-16.21.73-16.21Z",
    fill: "#d8742a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M351.785,339.89c-4.539,10.847-12.332,47.816,4.652,68.632l8.482-.018s-6.681-7.322-7.428-24.31,3.573-24.446,6.619-30.052,5.865-15.131,5.865-15.131Z",
    fill: "#ea8600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M345.8,272.639c-2.253,7.945-2.994,22.622,8.292,28.534l7.554-1.841s-13.618-7.14-10.7-25.184Z",
    fill: "#0b43a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M324.99,268.573l5.864-.723s-.706,24.622,27.731,26.7C380.292,296.129,382,336.864,382,336.864c-7,4.712-18.745,6.139-33.795,5.06,0,0,.963-29.061-1.427-37.017C346.776,304.907,323.149,297.473,324.99,268.573Z",
    fill: "#185abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M317.821,264.1c-.993,1.15,3.151,2.609,7.169,4.469l5.146-.635a20.238,20.238,0,0,0,0-2.1c-.064-1.072-.6-1.683-1.212-.763s-3.212,1.231-4.438.392S318.813,262.954,317.821,264.1Z",
    fill: "#ffb9a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M345.8,272.639c-1.885-1.854-1.385-1.741-1.385-1.741l5.751,1.3s1.265-2.806,2.336-2.885-.807,1.934-.377,2.68-1.179,2.155-1.179,2.155Z",
    fill: "#ffb9a3"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M373.408,276.506a6.151,6.151,0,0,1,3.828,1.3,2.838,2.838,0,0,1,.569,3.7",
    fill: "none",
    stroke: "#fbcb43",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M378.7,287.165a2.421,2.421,0,0,1,1.385,1.715,2.293,2.293,0,0,1-.652,1.779,6.771,6.771,0,0,1-1.561,1.167",
    fill: "none",
    stroke: "#fbcb43",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M365.513,293.21a7.131,7.131,0,0,0,8.223-1.008",
    fill: "none",
    stroke: "#fbcb43",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M378.964,278.426a2.252,2.252,0,0,1,.752,2.576,6.6,6.6,0,0,1-1.614,2.37",
    fill: "none",
    stroke: "#fbcb43",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M209.727,95.822l-2.346-5.729,22.63-8.592Z",
    fill: "#0b43a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M210.867,92.292,230.011,81.5,216.685,95.036Z",
    fill: "#5193f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M202.2,87.76,230.011,81.5l-22.63,8.592Z",
    fill: "#5193f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M210.867,92.292l-1.139,3.531,3.454-2.439Z",
    fill: "#0056ec"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M207.068,95.056c-5.908-1-13.928,4.975-10.478,11.2,1.175,2.119,7.232,1.2,6.781-1.143-.215-1.121-1.588-1.6-2.722-1.467-6.6.757-6.867,6.291-6.574,7.7,1.511,7.279,12.668,4.817,16.419,3.79",
    fill: "none",
    stroke: "#c8dbfb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopment);
export default __webpack_public_path__ + "static/media/webDevelopment.189851ceb1973ace04b0c570d97643b2.svg";
export { ForwardRef as ReactComponent };